import React from 'react'
import SettingsMetaData from '../../../../Components/Hooks/useSettingsMetaData'

function Type() {
  return (
    <SettingsMetaData propertyName={"type_equipments"} viewPropertyName={"Type"} />

  )
}

export default Type